//  Function: addViewportClass()
//  Author: Dustin Miller & Sarah McVicker
//  Date: 2017-01-30
//  Requires: jQuery, throttle, isElementInViewport
const $JQ = jQuery;

(function($){
  $.fn.addViewportClass = function( options ) {

    var settings = $.extend({
        // default settings
        viewEl: this,
        class: "inView",
        visibleOffset: null,
        visibleMinimum: 0,
        triggerScroll: false,
    }, options );
  
    var $window = $(window);

    if (typeof $addViewportClassElements !== 'undefined' && $addViewportClassElements.length > 0) {
      $addViewportClassElements.push(settings);
    }else{
      $addViewportClassElements = [settings];
    }

    if($addViewportClassElements.length){
      $window.off('scroll.viewportClass');
      $window.on('scroll.viewportClass',$.throttle(25,true,function() {
        for (var i = 0; i < $addViewportClassElements.length; i++) {
          $addViewportClassElements[i].viewEl.each(function(idx,itm){
            isInView = $(this).isElementInViewport({
              visibleOffset: $addViewportClassElements[i].visibleOffset,
              visibleMinimum: $addViewportClassElements[i].visibleMinimum
            });
            if(isInView){
              $(this).addClass($addViewportClassElements[i].class);
            }
          });
        }
      }));
    }
  
    if(settings.triggerScroll){
      $window.trigger('scroll');
    }
  }

})($JQ);
